import {
  ChallengeType,
  type RegisterIdentity,
  type RequestAttestation,
} from '~/interfaces/auth';

import { SignupHandler } from './signup-handler';

export class WhatsappHandler extends SignupHandler<
  RequestAttestation,
  RegisterIdentity
> {
  protected transformRequestBody(body: RequestAttestation): RegisterIdentity {
    const phone = body.data.phone;

    return {
      assertion_result: {
        challengeType: ChallengeType.OTP,
        alias: phone,
        value: {
          code: body.assert.code,
          phone: phone,
        },
      },
      extra_context: {},
      type: 'individual',
      profile: {
        first_name: body.data.name,
        last_name: body.data.lastName,
        email: body.data.email,
        phone: phone,
      },
    };
  }
}
